import RouteNames from '../../../../../../app/router/_internals/RouteNames.enum';

export default Object.freeze({
	GENERAL: `${RouteNames.SKILLS}-general`,
	AGENTS: `${RouteNames.SKILLS}-agents`,
});
